var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React, { useState, useEffect } from "react";
import Sticky from "react-sticky-el";
import "intersection-observer";
import { useScrollPercentage } from "react-scroll-percentage";
import "./styles.css";
function ScrollChanger(_ref) {
  var attached = _ref.attached,
    children = _ref.children,
    start = _ref.start,
    end = _ref.end,
    startOffset = _ref.startOffset,
    endOffset = _ref.endOffset,
    length = _ref.length,
    scrollOptions = _ref.scrollOptions,
    wrapperStyle = _ref.wrapperStyle,
    style = _ref.style;
  var _useScrollPercentage = useScrollPercentage(_extends({}, scrollOptions)),
    ref = _useScrollPercentage[0],
    percentage = _useScrollPercentage[1];
  var calculateAmount = function calculateAmount(start, end, percentage) {
    var amount = start - (start - end) * (percentage * (1 + endOffset) - startOffset);
    var max = start;
    var min = end;
    if (min > max) {
      min = start;
      max = end;
    }
    if (amount > max) {
      amount = max;
    }
    if (amount < min) {
      amount = min;
    }
    return amount;
  };
  return React.createElement("div", {
    ref: ref,
    className: "scroll-changer__wrapper",
    style: _extends({
      height: length * 100 + "vh"
    }, wrapperStyle)
  }, React.createElement(Sticky, {
    boundaryElement: ".scroll-changer__wrapper",
    disabled: !attached,
    hideOnBoundaryHit: false
  }, React.createElement("div", {
    style: _extends({}, style),
    className: "scroll-changer__inner"
  }, React.cloneElement(children, {
    scrollAmount: calculateAmount(start, end, percentage)
  }))));
}
ScrollChanger.defaultProps = {
  attached: true,
  startOffset: 0,
  endOffset: 0
};
export default ScrollChanger;